import clsx from 'clsx';

import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';

import DNotificationBlockTasks from '@/components/DNotificationBlock/tasks';
import DNotificationBlockUpdates from '@/components/DNotificationBlock/updates';

const DNotificationBlock = ({ fetchMore, loadingMore, hasMore }) => {
  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-col justify-center items-start self-stretch py-v3-xs px-v3-sm">
        <div className="flex h-8 items-center gap-v3-xs self-stretch">
          <h3 className="text-v3-h9 font-bold text-v3-black-secondary">Updates</h3>
        </div>
      </div>
      <DNotificationBlockUpdates
        fetchMore={fetchMore}
        loadingMore={loadingMore}
        hasMore={hasMore}
      />
    </div>
  );
};

export default DNotificationBlock;
